import { render, staticRenderFns } from "./TaskManagerHeader.vue?vue&type=template&id=eab8f892&"
import script from "./TaskManagerHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskManagerHeader.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports